import { Modal, Table } from "react-bootstrap";

/* ----------- COMPONENTS ----------- */
import styles from "components/admin/InfoTableModal/styles.module.scss";

interface InfoTableModalProps {
  show: boolean;
  onHide: () => void;
  title?: string;
  description?: string;  
  columns: string[];
  rows: (string | number)[][];
}

export default function InfoTableModal({
  show,
  onHide,
  title = "Información",
  description = "",
  columns,
  rows,
}: InfoTableModalProps) {

  return (
    <Modal show={show} onHide={onHide} centered size="lg" className={`${styles.table_import_modal_content}`}>
      <Modal.Header closeButton className={`${styles.table_import_modal_header}`}>
        <Modal.Title className={`${styles.table_import_title}`}>{title}</Modal.Title>
      </Modal.Header >
      <Modal.Body>
        <p>{description}</p>
        <Table bordered hover responsive className={`${styles.table_import}`}>
          <thead>
            <tr>
              {columns.map((col) => (
                <th key={col}>{col}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={`${i}-${j}`}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
    </Modal>
  );
}
